<template>
  <v-flex v-if="errors" xs12>
    <v-alert
      :key="key"
      :value="true"
      color="error"
      icon="warning"
      outline
      v-for="(value, key) in errors"
    >
      <template v-for="(item) in value">{{item}}</template>
    </v-alert>
  </v-flex>
</template>

<script>
export default {
  props: ["errors"]
};
</script>
